module.exports = __webpack_public_path__ + "img/charging-session-infograph-mobile-fr.720ff680.webp";